import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue";
const _hoisted_1 = { class: "notification-container" };
import { computed } from "vue";
import { useNotificationStore, } from "@/stores/notifications";
export default /*@__PURE__*/ _defineComponent({
    __name: 'NotificationSnackbar',
    setup(__props) {
        const notificationStore = useNotificationStore();
        const notifications = computed(() => notificationStore.notifications);
        function getIcon(type) {
            switch (type) {
                case "success":
                    return "mdi-check-circle";
                case "error":
                    return "mdi-alert-circle";
                case "warning":
                    return "mdi-alert";
                case "info":
                default:
                    return "mdi-information";
            }
        }
        return (_ctx, _cache) => {
            const _component_v_alert = _resolveComponent("v-alert");
            const _component_v_slide_y_reverse_transition = _resolveComponent("v-slide-y-reverse-transition");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_v_slide_y_reverse_transition, { group: "" }, {
                    default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(notifications.value, (notification) => {
                            return (_openBlock(), _createBlock(_component_v_alert, {
                                key: notification.id,
                                type: notification.type,
                                icon: getIcon(notification.type),
                                variant: "elevated",
                                density: "comfortable",
                                class: "notification-alert",
                                closable: "",
                                "onClick:close": ($event) => (_unref(notificationStore).remove(notification.id))
                            }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(notification.message), 1)
                                ]),
                                _: 2
                            }, 1032, ["type", "icon", "onClick:close"]));
                        }), 128))
                    ]),
                    _: 1
                })
            ]));
        };
    }
});
